import React from 'react';
import { Container, Box } from '@mui/material';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import MainRouting from '../routes/mainRouting';
import { useSelector } from 'react-redux';
import { RootState } from '../store/reducers';
import { Navigate } from 'react-router-dom';

import { getEstruturaLevelDisciplinas } from '../store/actions/estruturaDiscActions';
import { useGetProfile } from '../store/actions/AuthAction';
import { log } from '../utils/log';
import { hasNoSystemAccess } from '../utils/permissions';

interface iAppBase {}

const AppBase = (props: iAppBase) => {
    const isAuthenticatedold = useSelector(
        (state: RootState) =>
            state.auth.id !== null && state.auth.expiresIn * 1000 > new Date().getTime()
    );
    const isAuthenticated = useSelector(
        (state: RootState) => state.auth.id !== null && typeof state.auth.id !== 'undefined'
    );
    const auth = useSelector((state: RootState) => state.auth);
    const { error } = useGetProfile();

    if (!isAuthenticated) {
        log(2, 'AppBase nao autenticado');
        return <Navigate replace to="/login" />;
    }
    if (auth.roleLoaded && auth.roleName && hasNoSystemAccess(auth.roleName)) {
        log(2, 'AppBase sem acesso ao sistema (role: ' + auth.roleName + ')');
        return <Navigate replace to="/login" />;
    }

    log(3, 'AppBase.rendering...');

    return (
        <Box
            sx={{
                display: 'flex',
                minHeight: '100vh',
                bgcolor: 'background.default',
            }}
        >
            <TopBar isAuthenticated={isAuthenticated} auth={auth} />
            <Sidebar isAuthenticated={isAuthenticated} auth={auth} roleName={auth.roleName} />
            <Box
                component="main"
                id="mainAppContainer"
                sx={{
                    flexGrow: 1,
                    pt: '56px',
                    minHeight: '100vh',
                    overflow: 'auto',
                    transition: 'margin-left 0.28s ease',
                }}
            >
                <Box sx={{ p: { xs: 1.5, sm: 2, md: 2.5 }, minHeight: 'calc(100vh - 56px)' }}>
                    <MainRouting />
                </Box>
            </Box>
        </Box>
    );
};

export default AppBase;
